import { render, staticRenderFns } from "./UmbrellaMenu.vue?vue&type=template&id=9bb14448&scoped=true&"
import script from "./UmbrellaMenu.vue?vue&type=script&lang=ts&"
export * from "./UmbrellaMenu.vue?vue&type=script&lang=ts&"
import style0 from "./UmbrellaMenu.vue?vue&type=style&index=0&id=9bb14448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb14448",
  null
  
)

export default component.exports